import ReactDOM from 'react-dom';
import Me from './Me';

import './index.css';

ReactDOM.render(
    <Me />,
    document.body
);